import { PAGE_TYPE } from '@sravni/ugc/lib/organizations/constants';

import {
  SravniReviewsEnumsReviewFilter as FILTER_STATUS_OPTIONS,
  SravniReviewsEnumsReviewOrder,
  SravniReviewsEnumsReviewRateStatus as RATE_STATUS,
} from '../__generated__/reviews/reviewsApiTypes';
import { TReviewObjectType } from '../interfaces/reviews';

export const NUMBER_OF_REVIEWS = 10;
export const COMMENTS_LIST_LIMIT = 2;

export enum PRODUCT_TYPE {
  CREDIT_CARDS = 'karty',
  DEBET_CARDS = 'debetovye-karty',
  CREDITS = 'kredity',
  AUTO_CREDITS = 'avtokredity',
  IPOTEKA = 'ipoteka',
  VKLADY = 'vklady',
  VALJUTY = 'valjuty',
  PEREVODY = 'perevody',
  OBMEN_VALJUTY = 'obmen-valjuty',
  KASKO = 'kasko',
  OSAGO = 'osago',
  ZELENAJA_KARTA = 'zelenaja-karta',
  STRAHOVANIE_NEDVIZHIMOSTI = 'strahovanie-nedvizhimosti',
  VZR = 'vzr',
  KURSY = 'kursy',
  OBSLUZHIVANIE = 'obsluzhivanie',
  DRUGOE = 'drugoe',
  EGE_OGE = 'ege-oge',
  RKO = 'rko',
  VKLADY_BUSINESS = 'deposity-dlja-biznesa',
  CREDITS_BUSINESS = 'biznes-kredity',
}

export const BANKS_PRODUCTS = [
  PRODUCT_TYPE.CREDIT_CARDS,
  PRODUCT_TYPE.DEBET_CARDS,
  PRODUCT_TYPE.CREDITS,
  PRODUCT_TYPE.AUTO_CREDITS,
  PRODUCT_TYPE.IPOTEKA,
  PRODUCT_TYPE.VKLADY,
  PRODUCT_TYPE.VALJUTY,
  PRODUCT_TYPE.PEREVODY,
  PRODUCT_TYPE.OBMEN_VALJUTY,
];
export const INSURANCE_PRODUCTS = [
  PRODUCT_TYPE.KASKO,
  PRODUCT_TYPE.OSAGO,
  PRODUCT_TYPE.ZELENAJA_KARTA,
  PRODUCT_TYPE.STRAHOVANIE_NEDVIZHIMOSTI,
  PRODUCT_TYPE.VZR,
];
export const SCHOOL_PRODUCTS = [
  PRODUCT_TYPE.KURSY,
  PRODUCT_TYPE.OBSLUZHIVANIE,
  PRODUCT_TYPE.DRUGOE,
  PRODUCT_TYPE.EGE_OGE,
];

export enum FILTER_NAMES {
  SERVICE = 'tag',
  PRODUCT = 'product',
  SPECIFIC_PRODUCT = 'specificProduct',
  RATED = 'rated',
  RATE_STATUS = 'rateStatus',
  ORDER = 'orderBy',
  FILTER = 'filterBy',
  ORGANIZATION = 'reviewObjectId',
  REVIEWOBJECTTYPE = 'reviewObjectType',
  PAGE = 'page',
  LOCATION_GAR_ID = 'location',
  REGION_ID = 'regionId',
  PAGE_SIZE = 'pageSize',
  LOGO_URL = 'logoTypeUrl',
  ORGANIZATION_TYPE = 'organizationType',
  NEW_IDS = 'newIds',
  IS_LEGAL = 'isLegal',
  WITH_COMMENTS = 'withComments',
  WITH_VOTES = 'withVotes',
  FINGERPRINT = 'fingerPrint',
  IS_CLIENT = 'isClient',
  TYPE = 'type',
  FROM = 'from',
  TO = 'to',
  SQUEEZE_IDS = 'squeezesVectorIds',
}

export const ORDER_OPTIONS = {
  DATE: SravniReviewsEnumsReviewOrder.ByDate,
  POPULAR: SravniReviewsEnumsReviewOrder.ByPopularity,
  HIGH_RATE: SravniReviewsEnumsReviewOrder.HighRateFirst,
  LOW_RATE: SravniReviewsEnumsReviewOrder.LowRateFirst,
} as const;

export type ORDER_OPTIONS = typeof ORDER_OPTIONS[keyof typeof ORDER_OPTIONS];

export enum RATES_OPTIONS {
  ANY = 'any',
  GOOD = 'good',
  BAD = 'bad',
  FIVE = 'five',
  FOUR = 'four',
  THREE = 'three',
  TWO = 'two',
  ONE = 'one',
}

export {
  SravniReviewsEnumsReviewRateStatus as RATE_STATUS,
  SravniReviewsEnumsReviewFilter as FILTER_STATUS_OPTIONS,
} from '../__generated__/reviews/reviewsApiTypes';

export type FILTERS = {
  [FILTER_NAMES.RATE_STATUS]?: RATE_STATUS;
  [FILTER_NAMES.RATED]?: RATES_OPTIONS | RATES_OPTIONS[];
  [FILTER_NAMES.ORDER]?: ORDER_OPTIONS;
  [FILTER_NAMES.FILTER]?: FILTER_STATUS_OPTIONS;
  [FILTER_NAMES.SERVICE]?: string;
  [FILTER_NAMES.PRODUCT]?: string;
  [FILTER_NAMES.SPECIFIC_PRODUCT]?: string;
  [FILTER_NAMES.ORGANIZATION]?: string | number;
  [FILTER_NAMES.REVIEWOBJECTTYPE]?: TReviewObjectType;
  [FILTER_NAMES.ORGANIZATION_TYPE]?: TReviewObjectType;
  [FILTER_NAMES.PAGE]?: string | number;
  [FILTER_NAMES.PAGE_SIZE]?: number;
  [FILTER_NAMES.LOCATION_GAR_ID]?: number;
  [FILTER_NAMES.REGION_ID]?: string;
  [FILTER_NAMES.LOGO_URL]?: string;
  [FILTER_NAMES.NEW_IDS]?: boolean;
  [FILTER_NAMES.IS_LEGAL]?: boolean;
  [FILTER_NAMES.WITH_COMMENTS]?: boolean;
  [FILTER_NAMES.WITH_VOTES]?: boolean;
  [FILTER_NAMES.FINGERPRINT]?: string;
  [FILTER_NAMES.IS_CLIENT]?: string;
  [FILTER_NAMES.FROM]?: string;
  [FILTER_NAMES.TO]?: string;
  [FILTER_NAMES.SQUEEZE_IDS]?: string[];
};

export const DEFAULT_FILTERS: FILTERS = {
  [FILTER_NAMES.RATED]: RATES_OPTIONS.ANY,
  [FILTER_NAMES.ORDER]: ORDER_OPTIONS.POPULAR,
  [FILTER_NAMES.FILTER]: FILTER_STATUS_OPTIONS.WithRates,
  [FILTER_NAMES.SERVICE]: 'All',
  [FILTER_NAMES.PRODUCT]: 'All',
  [FILTER_NAMES.SPECIFIC_PRODUCT]: 'All',
  [FILTER_NAMES.ORGANIZATION]: null,
  [FILTER_NAMES.REVIEWOBJECTTYPE]: null,
  [FILTER_NAMES.PAGE]: '0',
  [FILTER_NAMES.PAGE_SIZE]: NUMBER_OF_REVIEWS,
  [FILTER_NAMES.LOCATION_GAR_ID]: null,
  [FILTER_NAMES.REGION_ID]: '',
  [FILTER_NAMES.NEW_IDS]: true,
  [FILTER_NAMES.IS_CLIENT]: 'false',
  [FILTER_NAMES.WITH_VOTES]: true,
  [FILTER_NAMES.SQUEEZE_IDS]: null,
};

export const UNNECESSARY_FILTERS: FILTERS = {
  [FILTER_NAMES.ORGANIZATION]: 'All',
};

export const EXCLUDE_TYPES = [
  'banki',
  'bank',
  'strakhovye-kompanii',
  'strakhovaja-kompanija',
  'mikrofinansovye-organizacii',
  'mikrofinansovaja-organizacija',
  'zaimy',
  'shkola',
  'kursy',
  'broker',
  'brokery',
  'npf',
  'leasing',
  'marketplace',
  'bankruptcy',
  'university',
  'bukmeker',
  'bukmekery',
  'raciony-kompanii',
];

export const EXCLUDE_PRODUCT_TYPES = ['zelenaja-karta'];

export enum ENTITY_TYPE {
  REVIEW = 'review',
  COMMENT = 'comment',
}

export const ENTITY_LABELS = {
  [ENTITY_TYPE.REVIEW]: 'отзыв',
  [ENTITY_TYPE.COMMENT]: 'комментарий',
};

export const MODERATOR_ROLES = ['admin', 'moderator'];

export const USER_MODERATOR_ROLES = ['Sravni.Reviews.Service-Moderator', 'Sravni.Reviews.Service-Admin'];

export const PRODUCT_PAGE_HEADING = {
  [PRODUCT_TYPE.CREDIT_CARDS]: 'Кредитная карта',
  [PRODUCT_TYPE.DEBET_CARDS]: 'Дебетовая карта',
  [PRODUCT_TYPE.CREDITS]: 'Кредит',
  [PRODUCT_TYPE.AUTO_CREDITS]: 'Автокредит',
  [PRODUCT_TYPE.IPOTEKA]: 'Ипотека',
  [PRODUCT_TYPE.VKLADY]: 'Вклад',
  [PRODUCT_TYPE.KURSY]: 'Курс',
  [PRODUCT_TYPE.RKO]: 'РКО',
  [PRODUCT_TYPE.VKLADY_BUSINESS]: 'Депозит для бизнеса',
  [PRODUCT_TYPE.CREDITS_BUSINESS]: 'Кредит для бизнеса',
};

export const OTHER_TAGS = ['All', 'serviceLevel', 'remoteService', 'other'];

export const ORDER_OPTIONS_LABELS = {
  [ORDER_OPTIONS.DATE]: 'Новые',
  [ORDER_OPTIONS.POPULAR]: 'Полезные',
  [ORDER_OPTIONS.HIGH_RATE]: 'Позитивные',
  [ORDER_OPTIONS.LOW_RATE]: 'Негативные',
};

export const ANSWERS_OPTIONS_LABELS = {
  [PAGE_TYPE.Bank]: 'С ответами банка',
  [PAGE_TYPE.Broker]: 'С ответами брокера',
  [PAGE_TYPE.StrakhovajaKompanija]: 'С ответами страховой',
  [PAGE_TYPE.Npf]: 'С ответами НПФ',
  [PAGE_TYPE.University]: 'С ответами вуза',
  [PAGE_TYPE.Bukmekery]: 'С ответами букмекера',
  [PAGE_TYPE.Zaimy]: 'С ответами от микрофинансовых организаций',
  [PAGE_TYPE.Leasing]: 'С ответами лизинговой компании',
  [PAGE_TYPE.Marketplace]: 'С ответами маркетплейса',
  [PAGE_TYPE.Bankruptcy]: 'С ответами компании по банкротству',
};

export enum CUSTOMER_TYPES {
  Individuals = 'individuals',
  Businesses = 'businesses',
  Both = 'both', // тип, который относится и к юрикам и к физикам
  All = 'all',
}

export const CUSTOMER_TYPE_TO_BOOLEAN = {
  [CUSTOMER_TYPES.Individuals]: false,
  [CUSTOMER_TYPES.Businesses]: true,
  [CUSTOMER_TYPES.All]: null,
};

export const BOOLEAN_STRING_TO_CUSTOMER_TYPE = {
  true: CUSTOMER_TYPES.Businesses,
  false: CUSTOMER_TYPES.Individuals,
  null: null,
};
